import { useQuery } from '@tanstack/react-query';
import api from '@app/services/api';
import { apiEndpoints } from '@app/utils/constants';
import type { UseQueryOptions } from '@tanstack/react-query';
import type {
	ApiError,
	AIAgentTypeListParams,
	AIAgentTypeListResponse,
} from '@app/services/api.types';

type QueryOptions = Omit<UseQueryOptions<AIAgentTypeListResponse, ApiError>, 'queryKey' | 'queryFn'>;

export const fetchAgentTypeList = async (
	params: AIAgentTypeListParams
): Promise<AIAgentTypeListResponse> => {
	const url = apiEndpoints.aiAgentTypes.getList(params);
	const response = await api.get(url);
	return response?.data?.data;
};

const useAgentTypes = (params: AIAgentTypeListParams = {}, options?: QueryOptions) => {
	return useQuery<AIAgentTypeListResponse, ApiError>({
		queryKey: ['ai-agent-type', 'list', params],
		queryFn: () => fetchAgentTypeList(params),
		...options,
	});
};

export default useAgentTypes;
